module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin17-07f84fdfd13df8bc3ce5f9adc1778f6c.jpg";